import comp from "./OrganizationResourceSelection";
export default comp;
